import { inject, Injectable, signal } from '@angular/core';
import { MaybeAsync } from '@angular/router';
import { OpenConfirmationModalService } from '@vendasta/galaxy/confirmation-modal';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ReputationSettingsUnsavedChangesGuard {
  private readonly confirmationModal = inject(OpenConfirmationModalService);
  private readonly hasUnsavedChanges = signal(false);

  canDeactivate(): MaybeAsync<boolean> {
    if (this.hasUnsavedChanges()) {
      return this.confirmationModal
        .openModal({
          type: 'warn',
          title: 'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.UNSAVED_CHANGES.TITLE',
          message: 'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.UNSAVED_CHANGES.MESSAGE',
          confirmButtonText: 'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.UNSAVED_CHANGES.CONFIRM',
        })
        .pipe(map((confirmation) => !!confirmation));
    }
    return true;
  }

  notifyStateChanged(hasChanges: boolean): void {
    this.hasUnsavedChanges.set(hasChanges);
  }
}


